let total = null;
const listeners = new Set();

export function getPubGraphisteAFaireCount() {
  return total;
}

export function setPubGraphisteAFaireCount(nextTotal) {
  const n = Number(nextTotal);
  if (Number.isNaN(n) || n < 0) return;
  total = n;
  listeners.forEach((listener) => listener(n));
}

export function subscribePubGraphisteAFaireCount(listener) {
  listeners.add(listener);
  if (total !== null) {
    listener(total);
  }
  return () => listeners.delete(listener);
}
